import React, { useState } from "react";
import { FaLinkedin, FaInstagram, FaYoutube } from "react-icons/fa";
import './Blog.css';

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const DS = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false); // Yükleniyor durumu

  // Sosyal medya bağlantıları
  const socialMediaLinks = [
    { name: "", url: "#", icon: <FaYoutube />, className: "youtube" },
    { name: "", url: "https://www.linkedin.com/in/avaliardagul/", icon: <FaLinkedin />, className: "linkedin" },
    { name: "", url: "https://www.instagram.com/av.aliarda_gul/", icon: <FaInstagram />, className: "instagram" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!email) {
      setMessage('Lütfen bir e-posta adresi girin.');
      setLoading(false);
      return;
    }

    try {
        const response = await fetch(`${apiUrl}/api/subscribers`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email }),
        });

        if (!response.ok) {
            const errorMessage = await response.text();
            console.error('Error:', errorMessage);
            setMessage('Bir hata oluştu. Lütfen tekrar deneyin.');
            setLoading(false);
            return;
        }

        const result = await response.json();
        setMessage(result.message || 'Başarıyla abone oldunuz!');
    } catch (error) {
        console.error('Hata:', error);
        setMessage(`Hata: ${error.message}`);
    }

    setEmail('');
    setLoading(false);
};

  return (
    <div className="subscription-container">
    {/* Abonelik Formu */}
    <h2 className="subscription-title">Yeni Abonelik</h2>
    <p className="subscription-description">
      En son güncellemeleri almak için abone olun.
    </p>
  
    <form onSubmit={handleSubmit} className="subscription-form">
      <div className="input-group">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-posta adresinizi girin"
          required
          className="email-input"
        />
        <button type="submit" className="submit-button" disabled={loading}>
          {loading ? 'Yükleniyor...' : 'Abone Ol'}
        </button>
      </div>
      {message && (
        <p className={`form-message ${message.includes('hata') ? 'error' : 'success'}`}>
          {message}
        </p>
      )}
    </form>
  
   

  
      {/* Sosyal Medya Bağlantıları */}
      
      <div className="social-media-section">
        <h2 className="section-title">Bizi Takip Edin</h2>
        <div className="social-media-links">
          {socialMediaLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`social-media-link ${link.className}`}
            >
              {link.icon} {link.name}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DS;
